// -- Helpers BEGIN
const windowLoad = require("%helpers%/window-load.js");
// -- Helpers END

windowLoad(function() {

});
